import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './services/xhr'

//引入重置样式
import './assets/css/reset.css'

//引入rem计算方法
import './utils/rem.js'

//引入拦截器
import './api/request'

//全局适用storejs
import storejs from "store";
Vue.prototype.$storejs = storejs

//全局适用axios
import axios from 'axios'
Vue.prototype.$http = axios

//判断运行环境
const u = navigator.userAgent;
let page = {
  isInApp: u.indexOf('Finger') !== -1 || u.indexOf('finger') !== -1, // 是否在app中
  isInWechat: u.indexOf('MicroMessenger') !== -1 && u.indexOf('wxwork') === -1, // 在普通微信中
  isInAlipay: u.toLowerCase().match(/AlipayClient/i) == "alipayclient", //在支付宝中
  isInMiniprogram: window.__wxjs_environment === "miniprogram", // 是否在小程序中
  isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // 是否是安卓
  isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否是ios
  bridge:window.WebViewJavascriptBridge
}
Vue.prototype.$page = page

//全局使用filter
import '@/filters/index.js'

//引入jq
import $ from "jquery";
window.$ = $

//引入toast清提示并挂载全局
import { Toast } from 'vant';
Vue.use(Toast);
Vue.prototype.$toast = Toast

//全局引入一日历
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar)

Vue.config.productionTip = false


import util from '@/libs/util.js'
router.beforeEach((to, from, next) => {
  // 进度条
  // NProgress.start()
  // 关闭搜索面板
  // store.commit('d2admin/search/set', false)
  // 验证当前路由所有的匹配中是否需要有登录验证的
  console.log(to.matched)
  // return
  if (to.matched.some(r => r.meta.auth)) {
    // 这里暂时将cookie里是否存有token作为验证是否登录的条件
    // 请根据自身业务需要修改
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      next()
    }else if(storejs.get("publicData")){
      if(location.href.indexOf('cps1.') != -1){
        next()
      }else{
        localStorage.removeItem('permissions')
        localStorage.removeItem('publicData')
        next({
          name: 'Login',
          query: {
            redirect: 'index'
          }
        })
      }

    } else {
      // 没有登录的时候跳转到登录界面
      // 携带上登陆成功之后需要跳转的页面完整路径
      next({
        name: 'Login',
        query: {
          redirect: 'index'
        }
      })
      // https://github.com/d2-projects/d2-admin/issues/138
      // NProgress.done()
    }
  } else {
    // 不需要身份校验 直接通过
    next()
  }
})

function mountApp(){
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

let urlQuery = util.urlParse()
if(urlQuery.c){
  storejs.set('publicData', {});
  axios.post("api/accountLogin/getAccountBasicByUrl", {
    shareUrl:urlQuery.c
  }).then((res)=>{
    console.log(res)
    if(res.code == 0){
        localStorage.removeItem('permissions')
        localStorage.removeItem('publicData')
        storejs.set('permissions', ['我要投保','cps订单']);
        res.t.isShare = true
        storejs.set('publicData', res.t);
      //  store.dispatch('d2admin/user/set', res.t, { root: true })
      mountApp()
      
    }else{
      // this.$message.error(res.msg)
      alert(res.msg)
      mountApp()
    }
  }).catch((err)=>{
    mountApp()
  })
  
}else{
  mountApp()
}


